import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const FormShortcut = ({ component: Component, open, handleClose, initialize, options }) =>
    (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <Component
                handleClose={handleClose}
                initialize={initialize}
                options={options}
            />
        </Dialog>
    );

FormShortcut.propTypes = {
    handleClose: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    component: PropTypes.elementType.isRequired,
    open: PropTypes.bool.isRequired,
    options: PropTypes.object
};

export default FormShortcut;
